import React, { useEffect, useState, useContext, useRef } from 'react'
import styles from './LaboralOtroProd.module.css'
import Subtitle from '../Subtitle'
import GeneralContext from '../../context/GeneralContext'

//Utiles
import * as Constantes from '../../utils/constantes'
import * as Funciones from '../../utils/funciones'

const LaboralOtroProd = ({ asegurado, contratante, state, setState }) => {
    const { state: generalState } = useContext(GeneralContext)
    let user = generalState.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

    const [girosEmpresa, setGirosEmpresa] = useState([])
    const [stateGirosEmpresa, setStateGirosEmpresa] = useState({})
    const giroRef = useRef()
    const [ocupaciones, setOcupaciones] = useState([])
    const [stateOcupaciones, setStateOcupaciones] = useState({})
    const ocupacionesRef = useRef()
    const [tipoLabores, setTipoLabores] = useState([])
    const [cargos, setCargos] = useState([])

    const [profesion, setProfesion] = useState([])
    const [stateProfesion, setStateProfesion] = useState({})
    const profesionRef = useRef()

    useEffect(() => {
        const cargarCombos = () => {
            setTipoLabores(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 3))
            setGirosEmpresa(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 7))
            setOcupaciones(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 9))
            setCargos(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 2))
            setProfesion(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 8))
        }
        cargarCombos()
    }, [])

    const handleChangeCombo = (event, campo) => {
        let codigo = event.target.value
        let descripcion = event.target[event.target.selectedIndex].text
        setState((state) => {
            return {
                ...state,
                asegurado: {
                    ...state.asegurado,
                    laboral: {
                        ...state.asegurado.laboral,
                        [campo]: {
                            codigo: parseInt(codigo),
                            descripcion: descripcion
                        }
                    }
                },
                campoValidado: {
                    ...state.campoValidado,
                    [campo]: true
                }
            }
        })
    }

    const handleChange = (e, campo) => {
        let valor = e.target.value.replace(/[^a-z A-Z À-ÿ \u00f1\u00d1]/gi, "")
        let capital = Funciones.mostrarCamelCase(valor)
        setState((state) => {
            return {
                ...state,
                asegurado: {
                    ...state.asegurado,
                    laboral: {
                        ...state.asegurado.laboral,
                        [campo]: capital
                    }
                },
                campoValidado: {
                    ...state.campoValidado,
                    [campo]: true
                }
            }
        })
    }

    const handleChangeNumerico2 = (e, campo) => {
        let value = e.target.value
        const re = /^[0-9\b.,]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            setState((state) => {
                return {
                    ...state,
                    asegurado: {
                        ...state.asegurado,
                        laboral: {
                            ...state.asegurado.laboral,
                            [campo]: Funciones.cantidadStringToFloat(value)
                        }
                    },
                    campoValidado: {
                        ...state.campoValidado,
                        [campo]: true
                    }
                }
            })
        }
    }

    const handleChangeProfesion = (event) => {
        if (event.target.value.length > 2) {
            let profesionFilter = profesion.filter(profesion => profesion.valor.toUpperCase().indexOf(event.target.value.toUpperCase()) >= 0)
            setStateProfesion({
                ...stateProfesion,
                descripcion: event.target.value,
                verProfesiones: true,
                profesionFilter: profesionFilter
            })
        } else {
            setStateProfesion({
                ...stateProfesion,
                descripcion: '',
                verProfesiones: false,
                profesionFilter: []
            })
            setState((state) => {
                return {
                    ...state,
                    asegurado: {
                        ...state.asegurado,
                        laboral: {
                            ...state.asegurado.laboral,
                            profesion: null
                        }
                    }
                }
            })
        }
    }

    const handleProfesionClick = (profesion) => {
        setStateProfesion({
            ...stateProfesion,
            descripcion: profesion.valor,
            profesion: profesion,
            verProfesiones: false,
            errorSeleccionandoProfesion: false
        })
        setState((state) => {
            return {
                ...state,
                asegurado: {
                    ...state.asegurado,
                    laboral: {
                        ...state.asegurado.laboral,
                        profesion: {
                            codigo: profesion.id,
                            descripcion: profesion.valor
                        }
                    }
                },
                campoValidado: {
                    ...state.campoValidado,
                    profesion: true
                }
            }
        })
        profesionRef.current.value = profesion.valor
    }

    ///// actualizar valor giro
    const handleChangeGiro = (event) => {
        if (event.target.value.length > 2) {
            let giroFilter = girosEmpresa.filter(giro => giro.valor.toUpperCase().indexOf(event.target.value.toUpperCase()) >= 0)
            setStateGirosEmpresa({
                ...stateGirosEmpresa,
                descripcion: event.target.value,
                verGiros: true,
                giroFilter: giroFilter
            })
        } else {
            setStateGirosEmpresa({
                ...stateGirosEmpresa,
                descripcion: '',
                verGiros: false,
                giroFilter: []
            })
            setState((state) => {
                return {
                    ...state,
                    asegurado: {
                        ...state.asegurado,
                        laboral: {
                            ...state.asegurado.laboral,
                            giro: null
                        }
                    }
                }
            })
        }
    }
    const handleGiroClick = (giro) => {
        setStateGirosEmpresa({
            ...stateGirosEmpresa,
            descripcion: giro.valor,
            giro: giro,
            verGiros: false,
            errorSeleccionandoGiro: false
        })
        setState((state) => {
            return {
                ...state,
                asegurado: {
                    ...state.asegurado,
                    laboral: {
                        ...state.asegurado.laboral,
                        giro: {
                            codigo: giro.id,
                            descripcion: giro.valor
                        }
                    }
                },
                campoValidado: {
                    ...state.campoValidado,
                    giro: true
                }
            }
        })
        giroRef.current.value = giro.valor
    }

    const handleChangeOcupacion = (event) => {
        if (event.target.value.length > 2) {
            let ocupacionFilter = ocupaciones.filter(ocupacion => ocupacion.valor.toUpperCase().indexOf(event.target.value.toUpperCase()) >= 0)
            setStateOcupaciones({
                ...stateOcupaciones,
                descripcion: event.target.value,
                verOcupaciones: true,
                ocupacionFilter: ocupacionFilter
            })
        } else {
            setStateOcupaciones({
                ...stateOcupaciones,
                descripcion: '',
                verOcupaciones: false,
                ocupacionFilter: []
            })
            setState((state) => {
                return {
                    ...state,
                    asegurado: {
                        ...state.asegurado,
                        laboral: {
                            ...state.asegurado.laboral,
                            ocupacion: null
                        }
                    }
                }
            })
        }
    }
    const handleOcupacionClick = (ocupacion) => {
        setStateOcupaciones({
            ...stateOcupaciones,
            descripcion: ocupacion.valor,
            ocupacion: ocupacion,
            verOcupaciones: false,
            errorSeleccionandoOcupacion: false
        })
        setState((state) => {
            return {
                ...state,
                asegurado: {
                    ...state.asegurado,
                    laboral: {
                        ...state.asegurado.laboral,
                        ocupacion: {
                            codigo: ocupacion.id,
                            descripcion: ocupacion.valor
                        }
                    }
                },
                campoValidado: {
                    ...state.campoValidado,
                    ocupacion: true
                }
            }
        })
        ocupacionesRef.current.value = ocupacion.valor
    }

    //Modo lectura
    let Deshabilitar = (complete) => {
        complete = cotizacion.edicionInhabilitada
        if (complete === true && complete !== undefined) {
            return true
        } else {
            return false
        }
    }

    return (
        <div className={styles['areadatosprospecto']}>
            <Subtitle
                sname="Laboral"
                smostrar="false"
            />
           
            <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                <div className={styles['area50']}>
                    <label>Empleador / Empresa&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <input type='text'
                        className={!state.campoValidado.empleadorEmpresa ? styles['logerror'] : null}
                        value={asegurado?.laboral.empleadorEmpresa || ''}
                        onChange={(e) => handleChange(e, 'empleadorEmpresa')}
                        disabled={Deshabilitar() !== true ? false : true}
                    />
                    {!state.campoValidado.empleadorEmpresa &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_EMPLEADOR_EMPRESA}</span>
                    }
                </div>
                <div className={styles['area25']}>
                    <label>Ingreso anual en S/ &nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <input
                        type='text'
                        className={!state.campoValidado.ingresoAnual ? `${styles['logerror']} ${styles['tipoLabores']}` : styles['tipoLabores']}
                        value={Funciones.formatoMonedaLaboral(asegurado?.laboral.ingresoAnual)}
                        options={{
                            numeral: false,
                            numeralThousandsGroupStyle: 'thousand'
                        }}
                        maxLength={9} //CMUNAYLLA: se cambia por la longitud pedida
                        onChange={(e) => handleChangeNumerico2(e, 'ingresoAnual')}
                        disabled={Deshabilitar() !== true ? false : true}
                    />
                    {!state.campoValidado.ingresoAnual &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_INGRESO_ANUAL}</span>
                    }
                </div>
            </div>

            <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                <div className={styles['area50']}>
                    <label>¿Cu&aacute;l es su profesi&oacute;n?&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <input type='text'
                        className={!state.campoValidado.profesion ? `${styles['logerror']} ${styles['profesion']}` : styles['profesion']}
                        defaultValue={(asegurado?.laboral && asegurado.laboral.profesion) ? asegurado?.laboral.profesion.descripcion : ''}
                        onChange={handleChangeProfesion}
                        disabled={Deshabilitar() !== true ? false : true}
                        ref={profesionRef}
                    />
                    <div className={styles['autocompletar']}>
                        <div id="myInputautocomplete-list" className={styles['autocomplete-items']}>
                            {stateProfesion.verProfesiones
                                ? stateProfesion.profesionFilter.map( profesion => (
                                    <div key={profesion.id} onClick={ event => handleProfesionClick(profesion)}>
                                        {profesion.valor.substring(0, profesion.valor.toUpperCase().indexOf(stateProfesion.descripcion.toUpperCase()))}
                                        <strong>{profesion.valor.substring(profesion.valor.toUpperCase().indexOf(stateProfesion.descripcion.toUpperCase()),
                                            profesion.valor.toUpperCase().indexOf(stateProfesion.descripcion.toUpperCase()) + stateProfesion.descripcion.length)}
                                        </strong>
                                        { profesion.valor.substring(
                                            profesion.valor.toUpperCase().indexOf(stateProfesion.descripcion.toUpperCase()) + stateProfesion.descripcion.length,
                                            profesion.valor.length
                                        )}
                                    </div>
                                ))
                                : null}
                        </div>
                    </div>
                    {!state.campoValidado.profesion &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_PROFESION}</span>
                    }
                </div>
            </div>

            <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                <div className={styles['area50']}>
                    <label>¿Cu&aacute;l es su ocupaci&oacute;n principal, es decir, la que genera mayor ingreso?&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <input type='text'
                        className={!state.campoValidado.ocupacion ? `${styles['logerror']} ${styles['ocupacion']}` : styles['ocupacion']}
                        defaultValue={(asegurado?.laboral && asegurado?.laboral.ocupacion) ? asegurado?.laboral.ocupacion.descripcion : ''}
                        onChange={handleChangeOcupacion}
                        ref={ocupacionesRef}
                        disabled={Deshabilitar() !== true ? false : true}
                    />
                    <div className={styles['autocompletar']}>
                        <div id="myInputautocomplete-list2" className={styles['autocomplete-items2']}>
                            {stateOcupaciones.verOcupaciones
                                ? stateOcupaciones.ocupacionFilter.map(ocupacion => (
                                    <div key={ocupacion.id} onClick={event => handleOcupacionClick(ocupacion)}>
                                        {ocupacion.valor.substring(0, ocupacion.valor.toUpperCase().indexOf(stateOcupaciones.descripcion.toUpperCase()))}
                                        <strong>{ocupacion.valor.substring(ocupacion.valor.toUpperCase().indexOf(stateOcupaciones.descripcion.toUpperCase()),
                                            ocupacion.valor.toUpperCase().indexOf(stateOcupaciones.descripcion.toUpperCase()) + stateOcupaciones.descripcion.length)}
                                        </strong>
                                        {ocupacion.valor.substring(
                                            ocupacion.valor.toUpperCase().indexOf(stateOcupaciones.descripcion.toUpperCase()) + stateOcupaciones.descripcion.length,
                                            ocupacion.valor.length
                                        )}
                                    </div>
                                ))
                                : null}
                        </div>
                    </div>
                    {!state.campoValidado.ocupacion &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_OCUPACION}</span>
                    }
                </div>
            </div>
                    
            <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                <div className={styles['area50']}>
                    <label>¿Cu&aacute;l es el giro en la que trabaja?&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <input type='text'
                        className={!state.campoValidado.giro ? `${styles['logerror']} ${styles['cargo']}` : styles['cargo']}
                        defaultValue={(asegurado?.laboral && asegurado.laboral.giro) ? asegurado?.laboral.giro.descripcion : ''}
                        onChange={handleChangeGiro}
                        disabled={Deshabilitar() !== true ? false : true}
                        ref={giroRef}
                    />
                    <div className={styles['autocompletar']}>
                        <div id="myInputautocomplete-list" className={styles['autocomplete-items']}>
                            {stateGirosEmpresa.verGiros
                                ? stateGirosEmpresa.giroFilter.map(giro => (
                                    <div key={giro.id} onClick={event => handleGiroClick(giro)}>
                                        {giro.valor.substring(0, giro.valor.toUpperCase().indexOf(stateGirosEmpresa.descripcion.toUpperCase()))}
                                        <strong>{giro.valor.substring(giro.valor.toUpperCase().indexOf(stateGirosEmpresa.descripcion.toUpperCase()),
                                            giro.valor.toUpperCase().indexOf(stateGirosEmpresa.descripcion.toUpperCase()) + stateGirosEmpresa.descripcion.length)}
                                        </strong>
                                        {giro.valor.substring(
                                            giro.valor.toUpperCase().indexOf(stateGirosEmpresa.descripcion.toUpperCase()) + stateGirosEmpresa.descripcion.length,
                                            giro.valor.length
                                        )}
                                    </div>
                                ))
                                : null}
                        </div>
                    </div>
                    {!state.campoValidado.giro &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_GIRO}</span>
                    }
                </div>
            </div>

            <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                <div className={styles['area25']}>
                    <label>¿Cu&aacute;l es el cargo que desempeña en su ocupación principal?&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <select
                        className={!state.campoValidado.cargo ? `${styles['logerror']} ${styles['cargo']}` : styles['cargo']}
                        value={(asegurado?.laboral && asegurado.laboral.cargo) ? (asegurado?.laboral.cargo.codigo === null ? 0 : asegurado?.laboral.cargo.codigo) : ''}
                        onChange={(e) => handleChangeCombo(e, 'cargo')}
                        disabled={Deshabilitar() !== true ? false : true}>
                        <option value={0}>Seleccione</option>
                        {cargos && cargos.length > 0 && cargos.map(cargo => (
                            <option key={cargo.id} value={cargo.id}>
                                {cargo.valor}
                            </option>
                        ))}
                    </select>
                    {!state.campoValidado.cargo &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_CARGO}</span>
                    }
                </div>
            </div>

            <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                <div className={styles['area25']}>
                    <label>¿Qu&eacute; tipo de labores realiza en su ocupaci&oacute;n principal?&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <select
                        className={!state.campoValidado.tipoLabores ? `${styles['logerror']} ${styles['tipoLabores']}` : styles['tipoLabores']}
                        value={(asegurado?.laboral && asegurado?.laboral.tipoLabores) ? ( asegurado?.laboral.tipoLabores.codigo === null ? 0 : asegurado?.laboral.tipoLabores.codigo ) : ''}
                        onChange={(e) => handleChangeCombo(e, 'tipoLabores')}
                        disabled={Deshabilitar() !== true ? false : true}>
                        <option value={0}>Seleccione</option>
                        {tipoLabores && tipoLabores.length > 0 && tipoLabores.map(tipoLabor => (
                            <option key={tipoLabor.id} value={tipoLabor.id}>
                                {tipoLabor.valor}
                            </option>
                        ))}
                    </select>
                    {!state.campoValidado.tipoLabores &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_TIPO_LABORES}</span>
                    }
                </div>
            </div>

        </div>
    )
}

export default LaboralOtroProd